import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKlantbelang = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M20 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M20 18a6 6 0 0 1 6 6v10H14V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17.017 12.533a3.02 3.02 0 1 0 6.006 0l.994-.106a4.02 4.02 0 1 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="m20 29.05-3.01 1.59.57-3.36-2.43-2.37 3.36-.49L20 21.36l1.51 3.06 3.37.49-2.44 2.37.57 3.36z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKlantbelang);

export default ForwardRef;
